import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import { accessLocalStorage, createContact, valuesAnalyze, changeViewForms } from '../../services';

import Loading from '../../components/Loading/LoadingModule';

import '../../libs/bulma.min.css';
import './ContactsCreate.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const EMPTY_ALERT = { show: false, type: '', message: '' };

function ContactsCreate() {
  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState({});
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);
  const [saving, setSaving] = useState(false);
  const [alert, setAlert] = useState(EMPTY_ALERT);

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const validateUserLogged = useCallback(() => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    if (!dataUser) return history.push('/');
    return setLoading(false);
  }, []);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber } = valuesAnalyze;

    if(name === 'cnpj') {
      const checkValueIsNumber = checkNumber(value);
      changeScreen(checkValueIsNumber, name);
      return checkValueIsNumber;
    };
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);
    setValues((prevState) => prevState, values[name] = value )
    if(Object.keys(validate).length >= 5) Object.values(validate).includes(false) ? setDisable(true) : setDisable(false);
    return;
  };

  const sendDataContactGenerate = async () => {
    setSaving(true);
    setAlert(EMPTY_ALERT);

    try {
      const result = await createContact(values);

      if (!result.success) {
        setAlert({ show: true, type: 'danger', message: result.error });
        return;
      }

      setAlert({ show: true, type: 'success', message: 'Contato criado com sucesso!' });
      changeVisibityMessages(true, 'create-form');
      changeVisibityMessages(true, 'button-send-form');
      setTimeout(() => {
        return history.push('/agenda/lista');
      }, 3000);
    } catch (error) {
      setAlert({ show: true, type: 'danger', message: 'Erro inesperado ao criar o contato. Tente novamente.' });
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  return (
    <div className="contacts-create-container">
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="contacts-create-header">
            <div className="contacts-create-title-wrapper">
              <svg className="contacts-create-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
              </svg>
              <div>
                <h1 className="contacts-create-title">Novo Contato</h1>
                <p className="contacts-create-subtitle">Preencha os dados para criar um novo contato</p>
              </div>
            </div>
            <Link to="/agenda/lista" className="btn-back">
              <FontAwesomeIcon icon={faArrowLeft} />
              Voltar
            </Link>
          </div>
          {alert.show && (
            <div className="alerts-section">
              <div className={`alert-message alert-${alert.type}`}>
                <div className="alert-header">
                  <span>{alert.type === 'success' ? 'Sucesso!' : 'Erro!'}</span>
                  <button className="alert-close" onClick={() => setAlert(EMPTY_ALERT)}>×</button>
                </div>
                <div className="alert-body">
                  {alert.message}
                </div>
              </div>
            </div>
          )}

          <div className="form-card">
            <form name="create-form" id="create-form" onSubmit={ (e) =>  e.preventDefault() }>
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">Razão Social</label>
                  <div className="form-control">
                    <input className="form-input" name="company" type="text" onChange={(e) => handleChangeValues(e.target)} placeholder="Razão Social" />
                    <p name="company-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                  </div>
                </div>
                <div className="form-field">
                  <label className="form-label">Nome Fantasia</label>
                  <div className="form-control">
                    <input className="form-input" name="fantasy" type="text" onChange={(e) => handleChangeValues(e.target)} placeholder="Nome Fantasia" />
                    <p name="fantasy-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                  </div>
                </div>
                <div className="form-field">
                  <label className="form-label">Endereço</label>
                  <div className="form-control">
                    <input className="form-input" name="addr" type="text" onChange={(e) => handleChangeValues(e.target)} placeholder="Rua Abc, 1000"/>
                    <p name="addr-invalid-data" className='form-error is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">CNPJ/CPF</label>
                  <div className="form-control">
                    <input className="form-input" name="cnpj" type="text" onChange={(e) => handleChangeValues(e.target)} placeholder="Apenas números"/>
                    <p name="cnpj-invalid-data" className='form-error is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                  </div>
                </div>
                <div className="form-field">
                  <label className="form-label">E-mail</label>
                  <div className="form-control">
                    <input className="form-input" name="email" type="text" onChange={(e) => handleChangeValues(e.target)} placeholder="empresa@email.com.br"/>
                    <p name="email-invalid-data" className='form-error is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                  </div>
                </div>
                <div className="form-field">
                  <label className="form-label">Apelido</label>
                  <div className="form-control">
                    <input className="form-input" name="alias" type="text" onChange={(e) => handleChangeValues(e.target)} placeholder="Apelido"/>
                    <p name="alias-invalid-data" className='form-error is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-field form-field-full">
                  <label className="form-label">Comentários</label>
                  <div className="form-control">
                    <input className="form-input" name="comment" type="text" onChange={(e) => handleChangeValues(e.target)} placeholder="Apenas texto e números. (-_,)"/>
                    <p name="comment-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                  </div>
                </div>
              </div>
            </form>
            
            <div id="button-send-form" name="button-send-form" className="form-actions">
              <Link to="/agenda/lista" className="btn-cancel">
                <FontAwesomeIcon icon={faArrowLeft} />
                Cancelar
              </Link>
              <button className="btn-submit" type="submit" disabled={saving} onClick={() => sendDataContactGenerate()}>
                <FontAwesomeIcon icon={faSave} />
                {saving ? 'Criando...' : 'Criar Contato'}
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default ContactsCreate;
